import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './production-instance.start-many.reducer';

export const startManyProductionInstancesFeatureKey = 'startManyProductionInstances';
export const featureSelector = createFeatureSelector<State>(startManyProductionInstancesFeatureKey);

export const getStartManyProductionInstancesRecord = createSelector(
  featureSelector,
  (state: State): null => state.record
);

export const getStartManyProductionInstancesLoaded = createSelector(
  featureSelector,
  (state: State): boolean => state.loaded
);

export const getStartManyProductionInstancesLoading = createSelector(
  featureSelector,
  (state: State): boolean => state.loading
);

export const getStartManyProductionInstancesError = createSelector(
  featureSelector,
  (state: State): any => state.error
);
